import {useCallback, useMemo, useState} from 'react';
import {useBetween} from 'use-between';
import {AuthorizeEsiaResponsePayload} from '../../../../shared/models/api/authorizeEsiaResponsePayload';
import {ParentSaturated, KidSaturated, Kid, KidValidated} from './model';
import {KidSubform} from '../components/form/model';

const RegCardStateHandler = () => {
  const [parent, setParent] = useState<ParentSaturated>();
  const [kids, setKids] = useState<KidSaturated[]>([]);

  const [confirmedKids, setConfirmedKids] = useState<KidSubform[]>([]);

  const addData = useCallback((esiaRegInfo: AuthorizeEsiaResponsePayload) => {
    if (esiaRegInfo.kids?.length) {
      const kidsSaturated: KidSaturated[] = esiaRegInfo.kids.map((kid) => {
        const kidValidated = kidValidator(kid);
        return {...kidValidated, checked: false, email: ''};
      });
      setKids(kidsSaturated);
    }
    setParent({...esiaRegInfo, checked: false});
  }, []);

  function kidValidator(kidToValidate: Kid) {
    const kidValidated: KidValidated = {...kidToValidate, errors: []};
    if (kidValidated.snils == null) {
      kidValidated.errors.push('СНИЛС');
    }
    if (kidValidated.documentVerified !== 'VERIFIED') {
      kidValidated.errors.push('cвидетельство о рождении');
    }
    return kidValidated;
  }

  const checkedKids = useMemo(() => {
    return kids.filter((kid) => kid?.checked === true);
  }, [kids]);

  return {
    kids,
    parent,
    setKids,
    setParent,
    addData,
    checkedKids,
    setConfirmedKids,
    confirmedKids,
  };
};

export const useRegCardState = () => useBetween(RegCardStateHandler);
